import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=788b7f51&scoped=true"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b7f51",
  null
  
)

export default component.exports